export default __webpack_public_path__ + "static/media/contactsBlack.a7066a03.svg";